module.exports = __webpack_public_path__ + "img/bull.2752f54e.svg";